import type { OnBoardingStore } from "@/Modules/OnBoarding/Store";
import type { GoToPoolApiQuery } from "@/Modules/Models/Api/OnBoarding";

import OnBoardingAPIConnector from "@/Services/TherapyApi/OnBoarding";

import { danger } from "@/Utils/Debug";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";

class GoToPoolActionHandler {
  constructor(
    private readonly onBoardingStore: OnBoardingStore,
    private readonly onBoardingApiConnector: OnBoardingAPIConnector = new OnBoardingAPIConnector()
  ) {}

  public async handle(therapistUuid?: string, therapistNameSelected?: string) {
    this.onBoardingStore.hasErrorInProcess = false;
    this.onBoardingStore.errorCode = null;
    this.onBoardingStore.isLoading = true;

    const apiQuery: GoToPoolApiQuery = {
      is_same_therapist: this.onBoardingStore.patientWantsLastTherapist,
      therapist_uuid: therapistUuid,
      therapist_name_selected: therapistNameSelected,
    };
    try {
      await this.onBoardingApiConnector.goToPool(apiQuery);
    } catch (err: unknown) {
      const code = isApiError(err) ? err["error_code"] : null;

      danger(code);

      this.onBoardingStore.hasErrorInProcess = true;
    } finally {
      this.onBoardingStore.isLoading = false;
    }
  }
}

export default GoToPoolActionHandler;
